import _ from 'lodash'
import React from 'react'

const Pagination = ({ limit, page, count, query = {}, onPageClick }) => {
  const totalPage = Math.ceil(count / limit)
  const onClick = (page, first, last) => {
    return () => {
      if (first && page !== 1) {
        onPageClick(_.merge(query, { page: 1 }))
      } else if (last && page !== totalPage) {
        onPageClick(_.merge(query, { page: totalPage }))
      } else {
        onPageClick(_.merge(query, { page }))
      }
    }
  }
  const pages = [
    <li key="0" className={`page-item ${page === 1 ? 'disabled' : ''}`}
        onClick={onClick(page, true, false)}>
      <a className="page-link" aria-label="Next">
        <i className="fa fa-angle-left"></i>
      </a>
    </li>
  ]
  const show = 2
  if (totalPage > (show * 2)) {
    let start = page - show > 0 ? page - show : 1
    let stop = page + show <= totalPage ? page + show : totalPage
    if (start === 1) {
      if (start + (show * 2) < totalPage) {
        stop = start + (show * 2)
      } else {
        stop = totalPage
      }
    }
    if (stop === totalPage) {
      if (stop - (show * 2) > 0) {
        start = stop - (show * 2)
      } else {
        start = 1
      }
    }
    for (let i = start; i <= stop; i++) {
      pages.push(
        <li key={i} className={`page-item ${page === i ? 'active' : ''}`}
            onClick={onClick(i)}>
          <a className="page-link">{i}</a>
        </li>
      )
    }
  } else {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${page === i ? 'active' : ''}`}
            onClick={onClick(i)}>
          <a className="page-link">{i}</a>
        </li>
      )
    }
  }
  pages.push(
    <li key={totalPage + 1} className={`page-item ${page === totalPage ? 'disabled' : ''}`}
        onClick={onClick(page, false, true)}>
      <a className="page-link" aria-label="Next">
        <i className="fa fa-angle-right"></i>
      </a>
    </li>
  )
  return (
    <div className="mg-l-15 d-flex align-items-center justify-content-center">
      <ul className="pagination pagination-basic pagination-primary mg-b-0">
        {pages}
      </ul>
    </div>
  )
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination.js